import { t } from '@lingui/core/macro'
import type {
  Citation,
  InspectionAnalysisCitation,
} from 'features/knowledgeDocumentViewer/components/advancedSearch/utils/documentSearchApiSchemas'

export function inspectionAnalysisCitationKey(
  citation: InspectionAnalysisCitation
): string {
  return [
    citation.tool,
    citation.unit_id,
    citation.component_id ?? '',
    citation.inspection_id ?? '',
  ].join('|')
}

/** The segment's inspection citations, one per analysis. */
export function collectInspectionAnalysisCitations(
  citations: Citation[]
): InspectionAnalysisCitation[] {
  const byKey = new Map<string, InspectionAnalysisCitation>()
  for (const citation of citations) {
    if (citation.type !== 'inspection_analysis') continue
    const key = inspectionAnalysisCitationKey(citation)
    if (!byKey.has(key)) byKey.set(key, citation)
  }
  return [...byKey.values()]
}

/** "Tank 404 · Shell · Inspection 2025-12-17", without the parts it lacks. */
export function inspectionAnalysisCitationLabel(
  citation: InspectionAnalysisCitation
): string {
  const parts = [citation.asset, citation.component].filter(
    (part): part is string => Boolean(part)
  )
  if (citation.inspection_date) {
    const date = citation.inspection_date
    parts.push(t`Inspection ${date}`)
  }
  return parts.length > 0 ? parts.join(' · ') : t`Inspection data`
}

/** The t-min method as Forecast names it, or the backend's name if unknown. */
export function inspectionTminMethodLabel(
  method: string | null | undefined
): string | null {
  switch (method) {
    case null:
    case undefined:
    case '':
      return null
    case 'api_653':
      return t`API 653`
    case 'api_570':
      return t`API 570`
    case 'shell_course':
      return t`t-min by shell course`
    case 'component':
      return t`t-min by component`
    case 'user':
      return t`t-min given by the user`
    default:
      return method
  }
}
